// ============================================================
// DISPOSIZIONE FISICA DEI PRODOTTI SUGLI SCAFFALI
//
// Ogni voce lega una COLLEZIONE Shopify a uno scaffale del
// negozio 3D. `collezione` è l'HANDLE della collezione (lo slug
// che vedi in Shopify admin → Prodotti → Collezioni, es.
// "bevande" per la collezione "Bevande").
//
// Un prodotto va sul primo scaffale la cui collezione gli
// appartiene; se nessuna corrisponde finisce su SCAFFALE_DEFAULT.
//
// Campi di uno scaffale:
//   start      [x, y, z] del PRIMO posto (la y viene dai livelli)
//   asse       'x' o 'z': direzione lungo cui si susseguono i prodotti
//   verso      +1 o -1 lungo l'asse
//   passo      distanza tra un prodotto e il successivo
//   livelli    altezze (y) dei ripiani, dal basso verso l'alto
//   perLivello quanti prodotti per ripiano prima di salire di livello
//   rotazioneY rotazione della scatola (radianti) perché guardi la corsia
//
// COME CALIBRARE: attiva "debugScaffali" nel pannello Leva
// (gruppo Scaffali) → appare una sferetta verde su ogni posto
// (arancioni = scaffale default). Aggiusta start/livelli/passo
// qui sotto finché le sferette poggiano sui ripiani del modello,
// eventualmente insieme a debugCollision per vedere i collider.
//
// Coordinate di partenza ricavate dai collider (Experience.jsx):
//   scaffale 1: centro x -6.91, z -5.53, lungo X, fronte verso z+
//   scaffale 2: centro x -6.92, z 7.174, lungo Z, fronte verso x+
//   scaffale 3: centro x -1.16, z 7.174, lungo Z, fronte verso x+
// Le ALTEZZE dei ripiani (livelli) sono da verificare sul modello.
// ============================================================

export const SCAFFALI = [
  // Scaffale 1, lato A: fronte verso la corsia centrale (z+)
  // NB: l'handle "shelf-1a" va impostato a mano su Shopify admin
  // (la collezione era la vecchia "Home page" rinominata, handle
  // originario "frontpage"): Collezioni → Shelf-1A → sezione
  // "Scheda del motore di ricerca" → Modifica → URL e handle.
  {
    collezione: 'shelf-1a', // collezione Shopify "Shelf-1A"
    start: [-9.9, 0, -4.7],
    asse: 'x',
    verso: +1,
    passo: 0.85,
    livelli: [1.65, 2.65, 3.7],
    perLivello: 6,
    rotazioneY: 0,
  },
  // Scaffale 1, lato B: il retro, fronte verso il muro Est (z-)
  {
    collezione: 'shelf-1b', // collezione Shopify "Shelf-1B"
    start: [-3.9, 0, -6.4],
    asse: 'x',
    verso: -1, // percorre lo scaffale al contrario: A e B si "danno le spalle"
    passo: 0.85,
    livelli: [1.8, 2.7, 3.7],
    perLivello: 6,
    rotazioneY: Math.PI,
  },
  // Scaffali 2 e 3 (lungo Z, fronte verso x+): aggiungi le collezioni
  // in Shopify (es. "Shelf-2A") e scommenta/duplica queste voci.
  // {
  //   collezione: 'shelf-2a',
  //   start: [-6.3, 0, 4.2],
  //   asse: 'z',
  //   verso: +1,
  //   passo: 1.0,
  //   livelli: [1.3, 2.3, 3.3],
  //   perLivello: 6,
  //   rotazioneY: Math.PI / 2,
  // },
]

// Prodotti senza collezione abbinata: la vecchia fila sospesa
// (stessa posizione di prima: [index-1, 3.8, -2])
export const SCAFFALE_DEFAULT = {
  collezione: null,
  start: [-1, 0, -2],
  asse: 'x',
  verso: +1,
  passo: 1.0,
  livelli: [3.8],
  perLivello: 99,
  rotazioneY: 0,
}

// Posizione del posto numero `i` (0-based) su uno scaffale:
// riempie un ripiano alla volta partendo dal PIÙ ALTO (all'altezza
// degli occhi) e scendendo; se i prodotti superano i posti, l'ultimo
// ripiano usato continua oltre la fine dello scaffale.
export function posizioneSlot(scaffale, i) {
  const fila = Math.min(
    Math.floor(i / scaffale.perLivello),
    scaffale.livelli.length - 1
  )
  const livello = scaffale.livelli.length - 1 - fila // dall'alto verso il basso
  const posto = i - fila * scaffale.perLivello
  const pos = [...scaffale.start]
  pos[1] = scaffale.livelli[livello]
  if (scaffale.asse === 'x') pos[0] += scaffale.verso * posto * scaffale.passo
  else pos[2] += scaffale.verso * posto * scaffale.passo
  return pos
}

// Numero stabile fra 0 e 1 ricavato dall'id del prodotto (hash): e' il
// "carattere" di quella scatola. Lo usano l'inclinazione sullo scaffale
// (qui sotto) e la fase del respiro (ProductBox.jsx). Deterministico
// apposta: a ogni ricaricamento la stessa scatola sta storta allo stesso
// modo, e fra un render e l'altro non sfarfalla.
export function semeDaId(productId) {
  let h = 0
  for (let i = 0; i < productId.length; i++) {
    h = (h * 31 + productId.charCodeAt(i)) | 0
  }
  return (((h % 1000) + 1000) % 1000) / 1000
}

// Rotazione "naturale": scarto di yaw deterministico per prodotto.
// ampiezza = rotazione massima totale in radianti.
export function rotazioneCasuale(productId, ampiezza) {
  return (semeDaId(productId) - 0.5) * ampiezza
}
